import { createContext } from 'react';

const DadosUsuario = createContext();

export default DadosUsuario;
